import modalCollection from './modalCollection.vue';

export default modalCollection;
